import React, {useState, useEffect} from 'react'
import './Header.scss'

import Logo from '../Assets/header/Logo.svg'
import Search from '../Assets/header/Search_alt.svg'

import Sun from '../Assets/header/sun.svg'
import Moon from '../Assets/header/moon.svg'
import Light_Moon from '../Assets/header/light_moon.svg'

import Create_Nft from '../Assets/header/create_nft_button.svg'

import Bag from '../Assets/header/bag_alt.svg'
import Wallet from '../Assets/header/wallet.svg'
import Profile_pic from '../Assets/header/profile_pic.svg'

import Menu from '../Assets/header/menu.svg'
import Burger from '../Assets/header/index.png'

import Ant from '../Assets/footer/ant-design.svg'
import Telegram from '../Assets/footer/telegram.svg'
import Twitter from '../Assets/footer/twitter.svg'
import TikTok from '../Assets/footer/tik_tok.svg'
import Github from '../Assets/footer/github.svg'
import Instagram from '../Assets/footer/instagram.svg'
import { NavLink, useHistory } from 'react-router-dom';

function Header(props) {
    
    useEffect(() => {
            localStorage.setItem("mode", JSON.stringify(props.darkMode));
    }, [props.darkMode])
    
    let [menuOpen, setMenuOpen] = useState(false)
    
    const adaptiveMenu = [
        { title: 'NFT Marketplace', to: '/market'}, 
        { title: 'Gallery', to: '/gallery'}, 
        { title: 'Creators', to: ''}, 
        { title: 'Investors', to: ''}, 
        { title: 'Litepaper', to: ''}, 
        { title: 'About', to: ''}, 
        { title: 'Team', to: ''}, 
        { title: 'Blog', to: ''}, 
        { title: 'Contact', to: ''}
    ] 

    const menu = adaptiveMenu.map((el, index) => {
        return(
            <NavLink onClick={() => setMenuOpen(!menuOpen)} to={el.to} key={index}>{el.title}</NavLink>
        )
    })

    const social_icons = [Ant, Telegram, Twitter, TikTok, Github, Instagram]

    const icons = social_icons.map((el, index) => {
        return(
            <img key={index} src={el} alt="social"/>
        )
    })
    const history = useHistory();
    return(
        <header className={props.darkMode ? "header dark" : "header"}>
            <div className="logo">
                <NavLink to="media_eye" onClick={() => document.querySelector('.path_select').value="/media_eye"}>
                    <img src={Logo} alt="logo" />
                </NavLink>
            </div>
            <div className="submenu">
                <div className="option_menu">
                    <select id="menu" className="path_select" onChange={(e) => history.push(e.target.value)}>
                        <option value="/media_eye">MeDIA eYe Marketplace</option>
                        <option value="/market">NFT Marketplace</option>
                        <option value="/gallery">Gallery</option>
                    </select>
                </div>
                <span>About</span>
                <span>Blog</span>
            </div>
            <div className="header_search">
                <input type="search" />
                <button>
                    <img src={Search} alt="search"/>                                    
                </button>
            </div>
            <div className="buttons">
                <button className={props.darkMode ? "mode_switcher" : "mode_switcher active" } onClick={() => props.setDarkMode(!props.darkMode)}>
                    <div className="day">
                        <img src={Sun} alt="light mode"/>
                        <div className="day_on" style={{marginLeft: props.darkMode ? "-50px" : "-9px"}}>
                            <img src={Sun} alt="light mode"/>
                        </div>
                    </div>
                    <div className="night">
                        <img src={Moon} alt="dark mode" />
                        <div className="night_on" style={{marginLeft: props.darkMode ? "-9px" : "30px"}}>
                            <img src={Light_Moon} alt="dark mode" />
                        </div>    
                    </div>
                    <div className="adaptive_dark_mode">
                        <img src={props.darkMode ? Sun : Moon} alt="mode"/>
                    </div>
                </button>
                <button style={{ backgroundImage: `url(${Create_Nft}), no-repeat center` }} onClick={() => props.setModalWindow(!props.modalWindow)}>
                    Create NFT
                </button>
                <div className="icon">
                    <button>
                        <img src={Bag} alt="bag"/>
                    </button>
                </div>
                <div className="icon">
                    <button>
                        <img src={Wallet} alt="wallet"/>
                    </button>
                </div>
                <button className="profile_pic">
                    <img src={Profile_pic} alt="profile pic"/>
                </button>      
                <div className="adaptive_menu">
                    <button style={{ background: 'none', border: 'none', width: menuOpen ? '60px' : '60px'}} onClick={() => setMenuOpen(!menuOpen)}>
                        <img src={menuOpen ? Burger : Menu } alt="menu" />
                    </button>
                </div>                          
            </div>
            <div className="adaptive_submenu" style={{left: !menuOpen ? '-100%' : '0' }}>
                {menu}
                <div>
                    {icons}
                </div>
                <div>
                    <button>Create NFT</button>
                    <button>Login</button>
                </div>
            </div>
        </header>
    )
}

export default Header;